import { api } from "./client";

export type Tenant = {
  id: string;
  name: string;
  slug: string;
  status: "active" | "muted" | "suspended" | "deleted";
  plan: string;
  created_at: string;
  expires_at: string | null;
};

export const tenantsApi = {
  list: () => api.get<Tenant[]>("/admin/tenants"),
  create: (payload: {
    name: string;
    slug: string;
    plan?: string;
    admin_email: string;
    admin_password: string;
    admin_full_name: string;
  }) => api.post<Tenant>("/admin/tenants", payload),
  update: (id: string, payload: Partial<{ name: string; plan: string; status: string; expires_at: string }>) =>
    api.patch<Tenant>(`/admin/tenants/${id}`, payload),
  remove: (id: string) => api.delete<void>(`/admin/tenants/${id}`),
};
